import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props: any) {
  return (
    <Svg
      width={49}
      height={49}
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M38.5075 15.0197C38.2694 14.7182 37.9227 14.5283 37.5429 14.4861L36.2467 14.3414C33.0395 13.9857 29.9347 12.994 27.1132 11.4266L25.1962 10.3625C24.7621 10.1214 24.2376 10.1214 23.8035 10.3625L21.8864 11.4266C19.0649 12.994 15.9602 13.9857 12.7529 14.3414L11.4567 14.4861C11.0769 14.5283 10.7303 14.7182 10.4922 15.0197C10.254 15.3181 10.1455 15.6979 10.1907 16.0777L11.0468 23.3031C11.5743 27.7643 13.9858 31.7885 17.6693 34.3627L23.6799 38.5587C24.1712 38.9054 24.8284 38.9054 25.3197 38.5587L31.3303 34.3627C35.0139 31.7885 37.4254 27.7643 37.9529 23.3031L38.8089 16.0777C38.8542 15.6979 38.7456 15.3181 38.5075 15.0197ZM30.8028 19.6075L22.8751 30.0975C22.7575 30.2722 22.5827 30.3326 22.3506 30.3326C22.1758 30.3326 22.0009 30.215 21.8834 30.0402L18.1546 24.0958C18.0371 23.8638 18.0371 23.5714 18.2119 23.3965C18.3867 23.2217 18.6791 23.1645 18.9112 23.279L22.2933 25.2021L29.9287 18.7936C30.1608 18.6188 30.5104 18.6188 30.7425 18.8509C30.9777 19.083 30.9777 19.3754 30.8028 19.6075Z"
        fill="#7EADEB"
      />
    </Svg>
  );
}

export default SvgComponent;
